import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetGiftTicketsByBenefitResponse } from '../responses/GetGiftTicketsByBenefitResponse';
import { VerifyCanOrderResponse } from '../responses/VerifyCanOrderResponse';
import { EndpointService } from './endpoint.service';


@Injectable({
  providedIn: 'root'
})
export class GiftTicketsService {

  constructor(private _http: HttpClient) { }


  verifyCanOrder(data) {
    return this._http.post<VerifyCanOrderResponse>(`${EndpointService.giftTicketBase}verifyCanOrder`, data);
  }

  getGiftTicketInfoByCompany(companyId: number) {
    const payload = {
      'paginationCriteria': {
        'start': 0,
        'limit': 999
      },
      'companyId': companyId
    };
    return this._http.post(EndpointService.getGiftTicketInfoByCompany, payload);
  }

  getGiftTicketInfoByCompanyForClient(companyId: number) {
    const payload = {
      'paginationCriteria': {
        'start': 0,
        'limit': 999
      },
      'companyId': companyId
    };
    return this._http.post(EndpointService.getGiftTicketInfoByCompanyForClient, payload);
  }

  getByBenefit(data: {
    'companyId': number;
    'benefitId': number;
  }) {
    return this._http.post<GetGiftTicketsByBenefitResponse>(`${EndpointService.giftTicketBase}get-by-benefit`, data);
  }


}
